export default __webpack_public_path__ + "img/search-base.17ca7f29.svg";